const state = {
  menus: [],
};

export default state;
